export default __webpack_public_path__ + "static/media/Recor360.8a21d0a5.svg";